import moment from 'moment'
import { hijriMonthsFull } from '@core/layouts/utils'

let baseDate = '01-01-2023'
let baseHijriDay = 8
let baseHijriMonth = 6
let baseHijriYear = 1444

const getAdjustment = (hijriMonth, hijriYear, adjustments) => {
  // - get no of days for particular month i.e 29 or 30. default is 30
  let hijriMonthYear = `${
    hijriMonth.toString()?.length === 1 ? '0' + hijriMonth : hijriMonth
  }-${hijriYear}`
  return adjustments[hijriMonthYear] ?? 30
}

const nth = function (d) {
  if (d > 3 && d < 21) return 'th'
  switch (d % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const getHijriDate = (date, adjustments = {}) => {
  let start = moment(baseDate, 'DD-MM-YYYY')
  let end = moment(date, 'DD-MM-YYYY')
  const difference = Math.abs(start.diff(end, 'days'))

  let hijriDay = baseHijriDay + difference
  let hijriMonth = baseHijriMonth
  let hijriYear = baseHijriYear
  let adjustment = getAdjustment(hijriMonth, hijriYear, adjustments)

  while (hijriDay > adjustment) {
    // - This loop adjusts the hijri day, month, and year based on the adjustment and the number of days in each month
    hijriDay -= adjustment
    hijriMonth += 1
    if (hijriMonth > 12) {
      hijriMonth = 1
      hijriYear += 1
    }
    adjustment = getAdjustment(hijriMonth, hijriYear, adjustments)
  }

  return {
    fullDate: `${hijriDay.toString().length === 1 ? '0' : ''}${hijriDay}${nth(
      hijriDay
    )} ${hijriMonthsFull[hijriMonth - 1].name}, ${hijriYear}`, // - ex: 01st Ramzaan, 1444
    hijriDay,
    hijriMonth,
    hijriYear
  }
}
